import React from "react";

export default function Footer() {
  const currentYear = new Date().getFullYear(); // Get the current year

  return (
    <footer className="bg-blue-900 text-white py-1.5 fixed bottom-0 w-full z-[5]">
      <div className="container mx-auto px-4 text-center text-xs tracking-wide">
        © {currentYear} Novius HABD (Lite). All rights reserved.
      </div>
    </footer>
  );
}
